import _ from 'lodash'
import { db } from '@/firebaseInit'
import Vue from 'vue'
import uuidv4 from 'uuid/v4'
import DateHelper from '@/lib/DateHelper'

const entityPlural = 'clubs'
const entitySingular = 'club'

const debug = require('debug')(`OD::Lib:Data:${_.startCase(_.toLower(entityPlural))}`)

export default {
  bindAll(vm) {
    debug(vm.$vnode.tag, 'bindAll')
    // const loadings = `loadings${_.capitalize(entityPlural)}`

    // Vue.set(loadings, true)
    Vue.set(vm.loadings, entityPlural, true)
    vm.$bind(entityPlural, db.collection(entityPlural))
      .then(items => {
        debug(vm.$vnode.tag, entityPlural, items)
        Vue.set(vm.loadings, entityPlural, false)
      })
      .catch(error => {
        debug(vm.$vnode.tag, entityPlural, 'error', error)
        // Vue.set(loadings, false)
        Vue.set(vm.loadings, entityPlural, false)
        Vue.set(vm.dbErrors, entityPlural, error)
      })
  },
  bindItem(vm, { clubId }, multiple) {
    debug(vm.$vnode.tag, 'bindItem', { clubId })
    const id = multiple ? `${entitySingular}_${clubId}` : entitySingular
    Vue.set(vm.loadings, id, true)
    vm.$bind(id, db.collection(entityPlural).doc(clubId))
      .then(item => {
        debug(vm.$vnode.tag, id, item)
        Vue.set(vm.loadings, id, false)
      })
      .catch(error => {
        debug(vm.$vnode.tag, id, 'error', error)
        Vue.set(vm.loadings, id, false)
        Vue.set(vm.dbErrors, id, error)
      })
  },
  add(vm, user, item) {
    if (user) {
      const userId = user.uid
      item.created = Date.now()
      item.createdBy = userId
      debug(vm.$vnode.tag, 'add', user, item)
      vm.$firestoreRefs[entityPlural].add(item).then(async newItem => {
        const clubId = newItem.id
        db.collection('users')
          .doc(userId)
          .collection('clubs')
          .doc(clubId)
          .set({
            created: Date.now(),
            createdBy: userId,
          })
          .then(() => {
            db.collection('clubs')
              .doc(clubId)
              .collection('users')
              .doc(userId)
              .set({
                created: Date.now(),
                createdBy: userId,
                role: 'admin',
              })
          })
      })
    }
  },
  update(vm, user, newItem, item) {
    debug(vm.$vnode.tag, 'update', { user, newItem, item })
    const dbRef = vm.$firestoreRefs[entityPlural]
      ? vm.$firestoreRefs[entityPlural].doc(item.id)
      : vm.$firestoreRefs[entitySingular]
    dbRef.update(newItem)
  },
  delete(vm, user, item) {
    if (user) {
      debug(vm.$vnode.tag, 'delete', { user, item })
      const userId = user.uid
      const clubId = item.id
      vm.$firestoreRefs[entityPlural]
        .doc(clubId)
        .delete()
        .then(() => {
          db.collection('clubs')
            .doc(clubId)
            .collection('users')
            .doc(userId)
            .delete()
            .then(() => {
              db.collection('users')
                .doc(userId)
                .collection('clubs')
                .doc(clubId)
                .delete()
            })
        })
    }
  },
  addSuggestion(vm, { clubId, data, key, duplicate }) {
    debug(vm.$vnode.tag, 'addSuggestion', { clubId, data, key, duplicate })
    let suggestionId = null
    if (vm.club) {
      let search = vm.club.search
      if (!search) {
        search = {}
      }
      if (!search[key]) {
        search[key] = []
      }
      debug('XXX1', { search, key, obj: search[key] })

      // INI - Resolve old strings to objects
      search[key].forEach((item, index) => {
        if (typeof item === 'string') {
          suggestionId = uuidv4()
          search[key][index] = Object.assign({ id: suggestionId, text: item })
        }
      })
      // END - Resolve old strings to objects

      debug('XXX1', { data })
      if (duplicate) {
        debug('DUPLICATE')
        const newData = Object.assign({}, data)
        delete newData.id
        suggestionId = uuidv4()
        search[key].push(Object.assign({ id: suggestionId }, newData))
      } else {
        if (data.id) {
          debug('UPDATE')
          suggestionId = data.id
          search[key].forEach((item, index) => {
            if (item.id === data.id) {
              search[key][index] = data
            }
          })
        } else {
          debug('NEW')
          suggestionId = uuidv4()
          search[key].push(Object.assign({ id: suggestionId }, data))
        }
      }

      // Order
      search[key] = search[key].sort((a, b) => {
        const textA = typeof a === 'object' ? a.text : a
        const textB = typeof b === 'object' ? b.text : b
        if (textA.toLowerCase() < textB.toLowerCase()) return -1
        if (textA.toLowerCase() > textB.toLowerCase()) return 1
        return 0
      })
      debug('SAVE', search)

      // Save
      const dbRef = vm.$firestoreRefs[entitySingular]
      dbRef.update({ search })
    }
    return suggestionId
  },
  deleteSuggestion(vm, { clubId, item, key }) {
    debug(vm.$vnode.tag, 'deleteSuggestion', { clubId, item, key })
    if (vm.club) {
      let search = vm.club.search
      if (!search) {
        search = {}
      }
      if (!search[key]) {
        search[key] = []
      }
      search[key] = _.remove(search[key], option => {
        if (typeof option === 'object') {
          return option.id !== item.id
        } else {
          return option !== item.text
        }
      })
      const dbRef = vm.$firestoreRefs[entitySingular]
      dbRef.update({ search })
    }
  },
  async validateInvitationCode(vm, user, { invitationCode }) {
    debug(vm.$vnode.tag, 'validateInvitationCode', user, { invitationCode })
    const maxNumUses = 3
    return db
      .collection('invitationCodes')
      .doc(invitationCode)
      .get()
      .then(doc => {
        if (doc.exists) {
          const obj = doc.data()
          if (obj.used) {
            return 'used'
          } else {
            const num = obj.times || 0
            const uses = obj.uses || []

            if (num >= maxNumUses) {
              return 'exceed_uses'
            }
            debug(vm.$vnode.tag, 'uses', uses)
            uses.push({ user: user.uid, date: DateHelper.getTodayLongString() })
            debug(vm.$vnode.tag, 'uses', uses)
            db.collection('invitationCodes')
              .doc(invitationCode)
              .update({
                times: num + 1,
                uses,
              })
            return 'ok'
          }
        } else {
          return 'invalid'
        }
      })
  },
}
